export const SESSION_DURATION = "ltk-session";
export const TOOLTIP_REFERRER_DISCOVER_PAGE_FOLLOW_TIMESTAMP = "tooltip-referrer-explore-displayName-timestamp";
export const TOOLTIP_REFERRER_POST_PAGE_LIKE_TIMESTAMP = "tooltip-referrer-explore-displayName-posts-id-timestamp";
